import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { seoHead } from '@/lib/seoHead';
import { DealsHub, dealsQuery } from '@/components/deals/DealsPages';
import { ComparisonError } from '@/components/comparison/ComparisonError';

const schema = z.object({
  q: z.string().max(80).optional(), category: z.string().max(80).optional(), loja: z.string().max(120).optional(), color: z.string().max(20).optional(), promo: z.coerce.number().int().min(0).max(1).optional(), audience: z.string().max(20).optional(),
  sort: z.enum(['discount', 'price', 'recent']).optional(), page: z.coerce.number().int().min(0).max(100).optional(),
  min: z.coerce.number().min(0).optional(), max: z.coerce.number().min(0).optional(),
});

export const Route = createFileRoute('/ofertas/')({
  validateSearch: schema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.ensureQueryData(dealsQuery(deps)),
  head: ({ loaderData }) => seoHead({
    title: 'Ofertas do Dia com Desconto Real | Shopping do Bem',
    description: 'Produtos em promoção nas lojas parceiras, com desconto real e doação para causas sociais sem custo extra.',
    path: '/ofertas', noindex: !loaderData?.items.length,
  }),
  component: () => <DealsHub search={Route.useSearch()} />,
  errorComponent: ({ reset }) => <ComparisonError reset={reset} />,
});
